import React from "react";
import { FunctionComponent } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import RegisterWidget from "../components/RegisterWidget";
import PageHeader from "../../../components/PageHeader";

interface RegisterPageProps {}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      height: "80vh",
    },
  },
  gridItem: {
    width: "100%",
  },
  paper: {
    flex: 1,
    padding: 35,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      paddingLeft: 20,
      paddingRight: 20,
      boxShadow: "none",
    },
  },
  header: {
    marginTop: 0,
  },
  boxTitle: {
    fontSize: 24,
    fontWeight: "bold",
  },
  boxCaption: {
    marginBottom: 20,
  },
}));

const RegisterPage: FunctionComponent<RegisterPageProps> = ({ ...props }) => {
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <Grid container justify={"center"} alignItems={"center"}>
        <Grid item sm={12} md={7} className={classes.gridItem}>
          <Paper className={classes.paper}>
            <PageHeader
              title={"Sign Up"}
              className={classes.header}
              subtitleProps={{ className: classes.boxCaption }}
              subtitle={"Please choose which user you are."}
              disableBackButton
            />
            <RegisterWidget />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RegisterPage;
